<template>
  <div>
    <oil-form v-if='loading'
              title='Создать поставщика'
              :items='supplier'
              :createForm='!id'
              :keys='keys'
              :success-message='message'
              :formCallback='formCallback'
    >
      <template v-slot:Contend='{input}' v-if='id'>
        <v-container fluid>
          <v-btn :disabled='!input.isEdit' outlined dense color='primary' @click='supplierAdd' class='mb-5'>Добавить
            ДОГОВОР
          </v-btn>
          <contend :item='supplier.Contracts' :disabled='!input.isEdit' :data='supplier'/>
        </v-container>
      </template>

    </oil-form>
  </div>
</template>

<script>
import data from './settng/importer.json'
import {comingSupplier} from '~/services/ComingSupplier'
import Contend from '~/pages/importer/settng/contend'

export default {
  props: {
    id: {
      type: String
    }
  },

  data: () => ({
    supplier: {
      Contracts: []
    },
    contractCounts: 0,
    keys: data,
    loading: false
  }),
  components: {
    Contend,
    OilForm: () => import('@/components/helper/oil.form'),
    DatePicker: () => import('@/components/helper/form/oil.date.picker'),
    contend: () => import('./settng/contend.vue')
  },

  computed: {
    message() {
      return this.id ? 'поставщик удачно именен' : 'поставщик удачно создан'
    },
    storeType() {
      return this.id ? comingSupplier.update : comingSupplier.create
    }
  },

  async created() {
    if (this.id) {
      const suppliers = await comingSupplier.getById(this.id)
      this.supplier = suppliers.data || []
      console.log(suppliers.data)
    }

    this.loading = true
  },
  methods: {
    supplierAdd() {
      this.supplier.Contracts.push({
        Number: '',
        StartDate: '',
        EndDate: '',
        Price: 0,
        Appendixes: [],
        Certifications: []
      })
    },
    async formCallback(data,input,form,func) {
      const response = await this.storeType(data)
      if (!response.data) return

      func(this.message)

      await this.$router.push('/coming-suppliers')
    }
  }
}
</script>